import "./UnitRoomMapCard.scss"
import React, {useState} from "react";
import {IRoomData} from "../../interfaces/IRoomData";
import {IRoomsData} from "../../interfaces/IRoomsData";
import {Tabs, TabsProps} from "antd";
import {useCurrencyConvert, useCurrencyState} from "../../store/CurrencyState";

interface UnitRoomMapCardProps {
  url: string,
  rooms: IRoomsData
}

export function UnitRoomMapCard(p: UnitRoomMapCardProps) {

  const e = Object.values(p.rooms).filter((v: IRoomData) => v && v.exist)
  const mA = Math.min(...e.filter((v: IRoomData) => v.minArea > 0).map((v: IRoomData) => v.minArea))
  const mP = Math.min(...e.filter((v: IRoomData) => v.minPrice > 0).map((v: IRoomData) => v.minPrice))
  const dA = e.find((v: IRoomData) => v.minPrice == mP) as (IRoomData | undefined)

  const [minArea, setMinArea] = useState(mA)
  const [minPrice, setMinPrice] = useState(mP)
  const [active, setActive] = useState(dA ? dA : undefined)

  const {currentCurrency} = useCurrencyState()
  const convert = useCurrencyConvert()

  const showStats = (apt: number) => {
    const ri = "r" + apt.toString()
    if (ri in p.rooms) {
      const rd = p.rooms[ri]
      setMinArea(rd.minArea);
      setMinPrice(rd.minPrice);
    }
    const newActive = e.find((v: IRoomData) => v?.rooms === apt)
    setActive(newActive as (IRoomData))
    return false
  }

  const goToFloor = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (active) {
      // updateUrl(p.url, {apts: active.rooms})
    } else {
      // updateUrl(p.url, {})
    }
    return false
  }

  const chTabs = (key: string) => {
    showStats(Number(key))
  }

  const items: TabsProps['items'] = [];
  if (p.rooms.r1.exist) items.push({key: "1", label: "1K", disabled: p.rooms.r1.count == 0})
  if (p.rooms.r2.exist) items.push({key: "2", label: "2K", disabled: p.rooms.r2.count == 0})
  if (p.rooms.r3.exist) items.push({key: "3", label: "3K", disabled: p.rooms.r3.count == 0})
  if (p.rooms.r4.exist) items.push({key: "4", label: "4K", disabled: p.rooms.r4.count == 0})

  return <div onClick={goToFloor}>
    <section>
      <span>від {minArea} м2</span>
      {
        active && active.count > 0 && currentCurrency
          ?
          <label>від {convert(minPrice)} {currentCurrency.currency_code}</label>
          :
          <label>ПРОДАНО</label>
      }
    </section>
    <div>
      <Tabs size="small" items={items} onChange={chTabs}/>
    </div>

    <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 10L6 5.5L1 1" stroke="currentColor" strokeWidth="2"/>
    </svg>

  </div>
}